import React from "react";
import styled from "styled-components";
import axios from "http/customAxios";
import { Alert, Button, Modal } from "react-bootstrap";
import { defineMessages, FormattedMessage } from "react-intl";
import Dropzone from "react-dropzone";
import EntityList from "../EntityList/EntityList";
import config from "./ModuleDefinition";
import { withUserAuthInfo } from "../../../../lib/auth";
const messages = defineMessages({
  import: {
    id: "app.filterList.import",
    description: "Import file",
    defaultMessage: "Import",
  },
  export: {
    id: "app.filterList.export",
    description: "export file",
    defaultMessage: "Export",
  },
  uploadFile: {
    id: "app.filterList.uploadFile",
    description: "Upload file",
    defaultMessage: "Choose a file",
  },
  uploadFilePlaceholder: {
    id: "app.filterList.uploadFilePlaceholder",
    description: "Upload file here",
    defaultMessage: "Upload file here",
  },
  importSuccess: {
    id: "app.filterList.importSuccess",
    description: "Upload success",
    defaultMessage: "Success!",
  },
  importError: {
    id: "app.filterList.importError",
    description: "Upload error",
    defaultMessage: "Error!",
  },
  dropHere: {
    id: "app.imageManager.dropHere",
    description: "Drop files here...",
    defaultMessage: "Drop files here...",
  },
});

const StyledDropzone = styled(Dropzone)`
  position: relative;
  width: 100%;
  min-height: 250px;
  height: 100%;
  border: 2px dashed #e0e0e0;
  border-radius: 5px;
  padding: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ButtonBarContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 15px;
  align-items: center;
  > * {
    margin-left: 10px;
  }
`;

const DropzoneContainer = styled.div`
  width: auto;
  height: 100px;
  border: 2px dashed #dae6e8;
  background-color: #${({ theme }) => theme.greyBackground};
  font-size: 21px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  margin-bottom: 25px;
`;

/* TODO: There's a problem with the API, on UPDATE the id changes, is that normal?
 * Also when updating and the entity does not exists it returns a 200 instead of a 404 */
class FilterList extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.handleToggle = this.handleToggle.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
    this.state = {
      entities: [],
      isModalOpen: false,
      file: false,
    };
  }

  componentDidMount() {}

  componentWillUnmount() {}

  handleToggle({ event, entity }) {
    event.preventDefault();
    event.stopPropagation();
    this.props.onToggleListItem({
      id: entity.id,
      entity,
      activeProperty: "active",
    });
  }

  handleDelete({ event, entity }) {
    event.preventDefault();
    event.stopPropagation();
    return this.props.onDeleteListItem({
      id: entity.id,
      entity,
    });
  }

  handleStartImport = () => {
    this.setState({ isModalOpen: true, fileError: false, fileSuccess: false });
  };

  handleStopImport = () => {
    this.setState({ isModalOpen: false });
  };

  handleImport = async () => {
    if (!this.state.file) {
      return;
    }
    const formData = new FormData();
    formData.append("file", this.state.file);
    const url = `${this.props.config.restConfig.baseURL}/${this.props.config.restConfig.upload
      .url({
        hotelTicker: this.props.hotelTicker,
      })
      .replace(/^\//, "")}`;
    try {
      this.setState({
        fileLoading: true,
        fileError: undefined,
        fileSuccess: undefined,
      });
      // TODO: replace with httpclient
      await axios.post(url, formData, {
        headers: {
          "content-type": "multipart/form-data",
        },
      });
      this.setState({ fileLoading: false, fileSuccess: true });
    } catch (e) {
      console.log(e);
      this.setState({ fileLoading: false, fileError: e });
    }
  };

  handleExport = async () => {
    const params = new URLSearchParams();
    this.props.locales.forEach(it => {
      params.append("locales", it);
    });
    const url = `${this.props.config.restConfig.baseURL}${this.props.config.restConfig.download.url(
      {
        hotelTicker: this.props.hotelTicker,
      }
    )}?${params.toString()}`;

    const response = await axios.get(url, {
      responseType: "blob", // Important for handling binary data
    });
    const blob = new Blob([response.data]);
    const blobUrl = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = blobUrl;
    a.download = `${this.props.hotelTicker}_filters.csv`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(blobUrl);
  };

  onDrop = files => {
    if (files && files.length > 0) {
      this.setState({ file: files[0] });
    }
  };

  render() {
    const { name, entityName, validation, fields, renderers, reorder } = config;
    const { handleToggle, handleDelete } = this;
    const { file } = this.state;
    const {
      entities,
      loading,
      entityError,
      entityResult,
      handleCreate,
      handleEdit,
      success,
      userInfo,
      userProfileEmail,
    } = this.props;
    return (
      <div>
        <div>
          <Modal show={this.state.isModalOpen} onHide={this.handleStopImport} bsSize="large">
            <Modal.Header closeButton>
              <Modal.Title>
                <FormattedMessage {...messages.uploadFile} />
              </Modal.Title>
            </Modal.Header>

            <Modal.Body>
              <div>
                <StyledDropzone onDrop={this.onDrop}>
                  {({ getRootProps, getInputProps }) => (
                    <DropzoneContainer {...getRootProps()}>
                      <input {...getInputProps()} />
                      {file ? (
                        <div>{file.name}</div>
                      ) : (
                        <div>
                          <FormattedMessage {...messages.uploadFilePlaceholder} />
                        </div>
                      )}
                    </DropzoneContainer>
                  )}
                </StyledDropzone>

                {this.state.fileSuccess && (
                  <Alert bsStyle="success">
                    <strong>
                      <FormattedMessage {...messages.importSuccess} />
                    </strong>
                  </Alert>
                )}
                {this.state.fileError && (
                  <Alert bsStyle="danger">
                    <strong>
                      <FormattedMessage {...messages.importSuccess} />
                    </strong>
                  </Alert>
                )}

                <Button className="btn btn-primary" onClick={this.handleImport}>
                  <FormattedMessage {...messages.import} />
                </Button>
              </div>
            </Modal.Body>
          </Modal>
          <ButtonBarContainer>
            <Button className="btn btn-primary" onClick={this.handleStartImport}>
              <FormattedMessage {...messages.import} />
            </Button>
            <Button className="btn btn-primary" onClick={this.handleExport}>
              <FormattedMessage {...messages.export} />
            </Button>
          </ButtonBarContainer>
        </div>
        <EntityList
          loading={loading}
          entityName={entityName}
          entities={entities}
          validation={validation}
          renderers={renderers}
          name={name}
          fields={fields}
          onToggle={handleToggle}
          onDelete={handleDelete}
          entityError={entityError}
          entityResult={entityResult}
          handleCreate={handleCreate}
          handleEdit={handleEdit}
          success={success}
          reorder={reorder}
          userProfileEmail={userProfileEmail}
          isWitAdmin={userInfo.isWitAdmin}
        />
      </div>
    );
  }
}

FilterList.propTypes = {};

FilterList.defaultProps = {
  entities: config.entities,
};

export default withUserAuthInfo(FilterList);
